import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationManagerService {

  private _openSource = new Subject();
  openSource$ = this._openSource.asObservable();

  private _closeSource = new Subject<any>();  
  closeSource$ = this._closeSource.asObservable();

  private _openTabSource = new Subject<number>();
  openTabSource$ = this._openTabSource.asObservable();

  onMenuOpen() {
    this._openSource.next(true);
  }

  onMenuClose(obj ?: any){
    this._closeSource.next(obj);
  }

  onOpenTab(index: number) {
    this._openTabSource.next(index);
  }
}
